import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { SubscribingComponent } from "app/common";
import { AppsFlyerService } from "app/shared/services/appsflyer/appsflyer.service";
import { AnimationOptions, LottieComponent } from "ngx-lottie";

@Component({
  selector: `app-thank-you-redirect`,
  templateUrl: "./thank-you-redirect.component.html",
  styleUrls: ["./thank-you-redirect.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [LottieComponent, TranslateModule]
})
export class ThankYouRedirectComponent extends SubscribingComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    super();
  }

  public lottieConfig: AnimationOptions<"canvas"> = {
    path: "../../../assets/anim/loader.json",
    renderer: "canvas",
    autoplay: true,
    loop: true
  };

  public static processingEndpoints: Array<string> = [
    "processing-upfront-standard",
    "processing-upfront-selfemployment",
    "processing-upfront-selfemployments",
    "processing-deferred-premium",
    "processing-deferred-selfemployment-premium"
  ];

  ngOnInit(): void {
    const statementId = this.route.snapshot.paramMap.get("statementId");
    const isPaypal = !!this.router.url.includes("paypal");
    const queryParams = this.route.snapshot.queryParams;

    AppsFlyerService.logEvent("package_purchase", this.router.url);

    if (isPaypal) {
      this.makeRedirect(`new/statement/${statementId}/payment-execute`, queryParams);
    } else if (
      ["processing-deferred-selfemployment-premium", "processing-deferred-premium"].some((fragment) =>
        this.router.url.includes(fragment)
      )
    ) {
      this.makeRedirect(`new/statement/${statementId}/vollmacht-authorization`);
    } else {
      this.makeRedirect(`/new/statement/${statementId}/thank-you`);
    }
  }

  private makeRedirect(pageAddress: string, queryParams?: any): void {
    setTimeout(() => {
      if (queryParams) {
        this.router.navigate([pageAddress], { queryParams: queryParams });
      } else {
        this.router.navigate([pageAddress]);
      }
    }, 3000);
  }
}
